import 'vuetify/styles'

// Resonaro design tokens — light (V1 Garden Notebook background)
const resonaroLight = {
  dark: false,
  colors: {
    background:           '#fbfaf6',  // V1 cream
    surface:              '#ffffff',  // cards
    primary:              '#9bb89b',  // sage accent (default)
    secondary:            '#5a5347',  // ink-soft
    error:                '#c62828',
    warning:              '#e65100',
    success:              '#2e7d52',
    info:                 '#1565c0',

    'on-primary':         '#2a2823',
    'on-secondary':       '#ffffff',
    'on-background':      '#2a2823',  // ink
    'on-surface':         '#2a2823',
    'on-error':           '#ffffff',
    'on-warning':         '#ffffff',
    'on-success':         '#ffffff',
    'on-info':            '#ffffff',

    'surface-variant':    '#f3efe6',  // warm paper
    'on-surface-variant': '#5a5347',  // ink-soft
    outline:              '#d4cfc7',  // hairline (rule-strong on white)
  }
}

// Dark counterpart — warm, low-chroma
const resonaroDark = {
  dark: true,
  colors: {
    background:           '#1c1a16',
    surface:              '#252320',
    primary:              '#b2c9b2',  // sage lightened
    secondary:            '#9a958a',  // ink-faint
    error:                '#ef5350',
    warning:              '#ff7043',
    success:              '#43a870',
    info:                 '#42a5f5',

    'on-primary':         '#1c1a16',
    'on-secondary':       '#1c1a16',
    'on-background':      '#f0ece4',
    'on-surface':         '#f0ece4',
    'on-error':           '#ffffff',
    'on-warning':         '#ffffff',
    'on-success':         '#ffffff',
    'on-info':            '#1c1a16',

    'surface-variant':    '#2e2b26',
    'on-surface-variant': '#c8c2b8',
    outline:              '#4a4842',
  }
}

export const appTheme = {
  defaultTheme: 'customLight',
  themes: {
    customLight: resonaroLight,
    customDark:  resonaroDark,
  },
  variations: {
    colors: ['primary', 'secondary', 'success', 'warning'],
    lighten: 4,
    darken:  4,
  }
}

export const appDefaults = {
  VBtn: {
    variant: 'flat',
    rounded: 'lg',
  },
  VCard: {
    elevation: 2,
  },
  VAppBar: {
    color: 'surface',
    elevation: 1,
  },
  VNavigationDrawer: {
    color: 'surface',
  },
  VTextField: {
    color: 'primary',
    variant: 'outlined',
  },
  VSelect: {
    color: 'primary',
    variant: 'outlined',
  },
}
